<template>
  <div class="bg-[#231F20] flex flex-row justify-center py-[12px] md:py-[24px]">
    <div
      class="font-aktiv-grotesk-medium font-bold text-white leading-[28px] text-[24px]"
    >
      Discipling
      <span
        ><span class="text-[#FFD639]">Generation</span
        ><span class="text-orange">S</span></span
      >
      <br class="block md:hidden" />
      to build a
      <span
        ><span class="text-orange">Stron</span
        ><span class="text-[#FFD639]">G</span></span
      >
      <span class="text-orange"> church</span>
    </div>
  </div>
</template>
